import { Language } from "react-localize-redux";

export const isFinnish = (language: Language): boolean => {
  return language.code === "fi";
};
